module.exports = __webpack_public_path__ + "img/novikov-tapper.adbc5b9.svg";